import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './initialState'

export const accountSlice = createSlice({
  name: 'Account',
  initialState,
  reducers: {
    setSignatureUploadProgress: (state, action) => {
      state.signatureSet.uploadProgress = action.payload
    },
    successSignatureUploadFile: (state, action) => {
      state.signatureSet.status = 1
      state.signatureSet.fileId = action.payload
    },
    failureSignatureUploadFile: (state) => {
      state.signatureSet.status = 2
      state.signatureSet.uploadProgress = 0
    },
    setSignatureCancelToken: (state, action) => {
      state.signatureSet.cancelToken = action.payload
    },
  },
})
